/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import {
  MediaStreamType,
  PlayerMedia,
  PlayerPlayInfo,
} from "../../shared/types";
import { PlayerSource } from "../BasePlayer";

export const usePlayerSource = (
  media: PlayerMedia,
  mediaPlayInfo: PlayerPlayInfo,
  streamType: MediaStreamType,
): PlayerSource | undefined => {
  const {
    MediaId,
    ContentUrl,
    ContentType,
    Widevine,
    PlayReady,
    FairPlay,
    Headers,
    Tracks,
  } = mediaPlayInfo || {};

  if (!ContentUrl) {
    return undefined;
  }

  const source: PlayerSource = {
    id: MediaId,
    src: ContentUrl,
    type: ContentType,
  };

  if (Headers && Headers.length > 0) {
    source.headers = {};
    for (const header of Headers) {
      source.headers[header.Name] = header.Value || "";
    }
  }

  const { AdUrl = "" } = media.CustomMetadata || {};
  // Do not show ads for Trailers
  source.adsTagUrl = streamType === MediaStreamType.Trial ? "" : AdUrl;

  if (Widevine || PlayReady || FairPlay) {
    source.keySystems = {};

    if (Widevine) {
      source.keySystems["com.widevine.alpha"] = Widevine.LicenseUrl;
    }

    if (PlayReady) {
      source.keySystems["com.microsoft.playready"] = PlayReady.LicenseUrl;
    }

    if (FairPlay) {
      source.keySystems["com.apple.fps.1_0"] = {
        certificateUri: FairPlay.CertificateUrl as string,
        licenseUri: FairPlay.LicenseUrl as string,
        options: {
          persistentState: "required",
        },
      };
    }
  }

  if (Tracks && Tracks.length) {
    source.subtitles = Tracks;
  }

  return source;
};
